module.exports = __webpack_public_path__ + "static/media/4-active.a775480c.png";